import * as realBoostMapper from '../../boost/mapper';
export class BoostMockMapper {
    isValidResponse(rawData) {
        return rawData.products && typeof rawData.total_product !== 'undefined';
    }
    mapProducts(products) {
        // Direct reuse of real Boost mapper
        return realBoostMapper.mapProducts(products);
    }
    mapFilters(filter, currentFilters) {
        // Direct reuse of real Boost mapper
        return realBoostMapper.mapFilters(filter, currentFilters);
    }
    mapMeta(rawData, page, pageSize) {
        // Direct reuse of real Boost mapper
        return realBoostMapper.mapMeta(rawData, page, pageSize);
    }
}
